// eslint-disable-next-line no-unused-vars
import React, { memo, useCallback } from 'react';
import uniqueId from 'lodash/uniqueId';

import CartMenuDropdownComponent from 'Components/Cart/CartMenuDropdown';
import ProductSkeletonItem from 'Components/Products/ProductSkeletonItem';
import ProductCartItem from 'Containers/Products/ProductCartItem';
import CartMenuSupplierComponent from 'Components/Cart/CartMenuSupplier';
import useCart from 'Hooks/useCart';
import useUser from 'Hooks/useUser';
import usePermissions from 'Hooks/usePermissions';
import { CURRENCY_RON } from 'Constants';
// import { UserContext } from 'Contexts/UserContext';
// import useUser from 'Hooks/useUser';
// import useWishlists from 'Hooks/useWishlists';

const CartMenuDropdown = memo(() => {
  // const { data: wishlists, createList } = useWishlists();
  const { data: cart, isLoading } = useCart();
  const { data: user } = useUser();
  const { isExternalReseller: IS_EXTERNAL_RESELLER } = usePermissions();
  const defaultCurrency = IS_EXTERNAL_RESELLER ? user?.defaultCurrency : CURRENCY_RON;

  // const handleOnAddToWishlist = () => {
  //   try {
  //     createList({
  //       name: new Date().toISOString().slice(0, 19).replace(/T/, ' '),
  //       default: false,
  //       products: cart.items.map(prod => ({
  //         productId: prod.id || prod.productId,
  //         quantity: prod.quantity
  //       }))
  //     });
  //     emptyCart();
  //   } catch (e) {
  //     // setErr(e.message);
  //   }
  // };

  const splitProductsBySupplier = useCallback(supplierProducts => {
    const groups = new Map();

    if (!supplierProducts) {
      return [];
    }

    supplierProducts.forEach(product => {
      const key = product.supplierId ?? 'default';

      if (!groups.has(key)) {
        groups.set(key, []);
      }

      groups.get(key).push(product);
    });

    const result = Array.from(groups.entries()).map(([supplierId, items]) => {
      const totalValue = items.reduce((sum, item) => sum + (item.totalPrice || 0), 0);

      return {
        supplierId,
        products: items,
        totalValue,
        ...(supplierId !== 'default' && items.length > 0 && {
          supplierOfferDeliveryTimeDays: items[0].supplierOfferDeliveryTimeDays
        })
      };
    });

    // show NOD products first
    // eslint-disable-next-line no-nested-ternary
    return result.sort((a, b) => (a.supplierId === 'default' ? -1 : b.supplierId === 'default' ? 1 : 0));
  }, []);

  const renderProducts = useCallback(
    productData => productData
      .filter(item => item.quantity)
      .map(cartItem => {
        return cartItem?.code
          ? (
            <ProductCartItem
              key={ cartItem.itemId }
              product={ cartItem }
              defaultCurrency={ defaultCurrency }
              isExternalReseller={ IS_EXTERNAL_RESELLER }
            />
          )
          : (
            <ProductSkeletonItem
              key={ cartItem.itemId || uniqueId('cartItemSkeleton_') }
            />
          );
      }),
    [cart?.items, user?.defaultCurrency]
  );

  const productsBySuppliers = splitProductsBySupplier(cart?.items || []);

  return (
    <CartMenuDropdownComponent
      items={ cart?.items }
      total={ cart?.total }
      isLoading={ isLoading }
      totalProducts={ cart?.totalItems }
      defaultCurrency={ IS_EXTERNAL_RESELLER ? user?.defaultCurrency : CURRENCY_RON }

      // wishlists={ wishlists }
      // isFloating={ isFloating }
      // user={ user }
      // loading={ isLoading }
      // error={ error?.message || null }
      // onMoveToWishlist={ handleOnAddToWishlist }
    >
      { productsBySuppliers.map((items, index) => (
        <CartMenuSupplierComponent
          key={ items.supplierId }
          supplierId={ items.supplierId }
          supplierIndex={ index }
          supplierOfferDeliveryTimeDays={ items.supplierOfferDeliveryTimeDays }
        >
          { renderProducts(items.products) }
        </CartMenuSupplierComponent>
      )) }
    </CartMenuDropdownComponent>
  );
});

CartMenuDropdown.propTypes = {
  // isFloating: bool,
};
CartMenuDropdown.displayName = 'CartMenuContainer';

export default CartMenuDropdown;
